import React, { FunctionComponent } from "react";
import { NamedProperty, CodedProperty } from "sprint-common-web";

import { AncillaryContentSubtype } from "../../../../../common/types/AncillaryContentType";
import { PageHeader } from "../../../../../common/ui/layout/header/PageHeader";
import { AuthorizationWrapper } from "../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../core/security/SprintAccessRight";
import { AncillaryDetailsPageBreadcrumbs } from "../../../common/header/ancillary/AncillaryDetailsPageBreadcrumbs";
import { CloudAssetDetailsPageHeaderActions } from "../CloudAssetDetailsPageHeaderActions";

interface AncillaryDetailsPageHeaderProps {
    contentType: AncillaryContentSubtype;
    ancillary: NamedProperty;
    airline: CodedProperty;
    deliveryFileName: string;
    filePath: string;
    cloudFileId: string;
    cloudAssetId: string;
    hideActions?: boolean;
}

export const CloudAncillaryDetailsPageHeader: FunctionComponent<AncillaryDetailsPageHeaderProps> = (
    props: AncillaryDetailsPageHeaderProps
) => {
    const {
        contentType,
        ancillary,
        airline,
        deliveryFileName,
        filePath,
        cloudFileId,
        cloudAssetId,
        hideActions
    } = props;

    return (
        <PageHeader>
            <AncillaryDetailsPageBreadcrumbs contentType={contentType} ancillary={ancillary} airline={airline} />
            <AuthorizationWrapper accessRights={[SprintAccessRight.AssetsReadWrite]}>
                {!hideActions && (
                    <CloudAssetDetailsPageHeaderActions
                        cloudFileId={cloudFileId}
                        deliveryFileName={deliveryFileName}
                        filePath={filePath}
                        cloudAssetId={cloudAssetId}
                    />
                )}
            </AuthorizationWrapper>
        </PageHeader>
    );
};
